import styled from 'styled-components'
import { motion } from 'framer-motion'
import { device } from '@styles/global/breakpoints'

export const faqAnswerVariants = {
  open: {
    height: 'auto',
    transition: {
      delay: .2,
      ease: 'backInOut',
    },
  },
  closed: {
    height: 0,
  },
}
export const FaqAnswer = styled(motion.div)<{
  textcolor: string | undefined
  textactivatedcolor: string | undefined
  isopen: 'true' | 'false'
}>`
  color:${props => props.textcolor
  ? props.isopen === 'true'
    ? props.textactivatedcolor 
    : props.textcolor
  : props.theme.headlineColor};
  padding: 0 20px;
  overflow: hidden;
  max-width: 750px;
  line-height: 26px;
`
export const FaqCloseBtn = styled.span<{ isOpen: boolean }>`
      position:absolute;
      top: 0;
      right: 0;
      width: 21px;
      height: 21px;
      z-index: 2;
      
 &:before, &:after{
      width: 21px;
      height: 1px;
      background: #fff;
      opacity: ${props => props.isOpen ? '1' : '.5'};
      position: absolute;
      transform: ${props => props.isOpen ? 'rotate(-45deg)' : 'rotate(0)'};
      content:'';
      top: 13px;
      // left: -35px;
      right: 0;
      transition: .3s;
    }
    &:after{
      transform: ${props => props.isOpen ? 'rotate(45deg)' : 'rotate(90deg)'};
      top: 13px;
      width: 21px;
    }
`
interface IFAQItemC {
  isopen: 'true' | 'false'
  textactivatedcolor: string | undefined
  textcolor: string | undefined
}

export const FAQItemC = styled.div<IFAQItemC>`
  position: relative;
  padding: ${props => props.isopen === 'true' ? '40px 0 40px' : '5px 0 25px'};
  cursor: pointer;
  background: ${props => props.isopen === 'true' ? props.theme.highlight.i300 : 'transparent'};
  transition: .3s;
  ${props => props.isopen === 'true' ? `
  margin-bottom: 30px;` : ''};
  
  h3{
    position: relative;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    padding: ${props => props.isopen === 'true' ? '0 40px 0 20px' : '0 40px 0 0'};
    color:${props => props.textcolor
  ? props.isopen === 'true' 
    ? props.textactivatedcolor 
    : props.textcolor
  : props.theme.headlineColor};
    transition: .3s;
    margin-bottom: 15px;
    margin-right: 25px;
    position: relative;
   
    @media ${device.tablet}{
      font-size: 21px;
      max-width: 750px;
    }
  }
  
  @media ${device.laptop}{
    &:hover{ 
      h3{
        padding-left: 20px;
        color: ${props => props.isopen === 'true'
  ? props.textcolor
    ? props.textactivatedcolor : props.theme.headlineColor
  : props.theme.highlight.i500};
      }
    }
  }
  
`
